import { ImageBg } from 'src/components/tag-tooltip/styles';
import { FC, useLayoutEffect, useRef, useState } from 'react';
import { GalleryButton } from 'src/components/gallery/styles';
import Icon from 'src/units/Icon';
import { DeviceManager, dvhToPixels } from 'src/utils';
import { IframeItem } from 'src/components/gallery/IframeItem';
import { MediaItemProps, MediaItemStyle } from 'src/components/tag-popup/Components/types';

export const MediaItem: FC<MediaItemProps & { children?: any }> = ({
  url,
  type = MediaItemStyle.Popup,
  innerStyle = {},
  settings = { adminPanelAccess: false },
  inFullScreen,
  toggleFullScreen,
}) => {
  const [minHeightMobile, setMinHeightMobile] = useState(0);
  const [minHeightTooltip, setMinHeightTooltip] = useState(0);
  const containerRef = useRef<any>(null);

  useLayoutEffect(() => {
    if (containerRef.current) {
      const aspectRatio = 1920 / 1080;
      const calculatedHeight = containerRef.current?.offsetWidth / aspectRatio;

      setMinHeightMobile(
        containerRef.current?.offsetWidth >= (270 / 9) * 16
          ? 270
          : DeviceManager.isMobile()
          ? dvhToPixels(70)
          : calculatedHeight,
      );
      setMinHeightTooltip(calculatedHeight);
    }
  }, []);

  const renderItem = () => {
    if (url.endsWith('.mp4')) {
      return (
        <video
          playsInline
          controls
          src={`${
            settings.adminPanelAccess
              ? // @ts-ignore
                import.meta.env.VITE_APP_AWS
              : process.env.NEXT_PUBLIC_CDN
          }${url}`}
          style={{
            width: '100%',
            height: '100%',
            margin: 'auto',
            objectFit: 'contain',
            aspectRatio: '1920/1080',
            ...innerStyle
          }}
        />
      );
    }
    if (
      url.endsWith('.jpg') ||
      url.endsWith('png') ||
      url.endsWith('.gif') ||
      url.endsWith('.webp')
    )
      return (
        <img
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            aspectRatio: '1920/1080',
            ...innerStyle
          }}
          src={`${
            settings.adminPanelAccess
              ? // @ts-ignore
                import.meta.env.VITE_APP_AWS
              : process.env.NEXT_PUBLIC_CDN
          }${url}`}
        />
      );

    if (url.includes('youtube.com') || url.includes('vimeo.com')) {
      return (
        <iframe
          src={`${
            settings.adminPanelAccess
              ? // @ts-ignore
                import.meta.env.VITE_APP_AWS
              : process.env.NEXT_PUBLIC_CDN
          }${url}`}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title={`iframe-0`}
          style={{
            width: '100%',
            height: '100%',
            aspectRatio: '1920/1080',
            ...innerStyle
          }}
        />
      );
    }
    if (url.endsWith('.pdf')) {
      const urlDefault = `${
        settings.adminPanelAccess
          ? // @ts-ignore
            import.meta.env.VITE_APP_AWS
          : process.env.NEXT_PUBLIC_CDN
      }${url}`;
      return <IframeItem item={urlDefault} index={0} useGoogleViewer />;
    }

    return null;
  };

  return (
    <ImageBg
      style={{
        marginBottom: '6px',
        ...(type === 'popup' && {
          maxHeight: DeviceManager.isMobile() ? `${minHeightMobile}px` : `${minHeightTooltip}px`,
        }),
        ...(type === 'popup' && {
          height: `max-content`,
        }),
        ...(type === 'tooltip' && {
          maxHeight: `${minHeightTooltip}px`,
        }),
        ...(type === 'tooltip' && {
          height: `max-content`,
        }),
        position: 'relative',
        overflow: 'hidden',
      }}
      ref={containerRef}
    >
      {type === 'popup' &&
        (inFullScreen ? (
          <GalleryButton
            style={{
              position: 'fixed',
              top: DeviceManager.isMobile() ? '14px' : `20px`,
              right: DeviceManager.isMobile() ? '14px' : '20px',
            }}
            onClick={() => toggleFullScreen(containerRef)}
          >
            <Icon.Close
              style={{ color: 'white', width: '100%', height: '100%' }}
              fontSize="large"
            />
          </GalleryButton>
        ) : (
          <GalleryButton
            style={{
              position: 'absolute',
              bottom: `${20}px`,
              right: '20px',
              background: 'rgba(0, 0, 0, 0.1)',
              // @ts-ignore
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
              },
              // @ts-ignore
              ' &:focus': {
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
              },
            }}
            onClick={() => toggleFullScreen(containerRef)}
          >
            <Icon.FullScreen />
          </GalleryButton>
        ))}
      {renderItem()}
    </ImageBg>
  );
};
